/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Injectable} from '@angular/core';
import {AbstractResourceService, JsonApiListResourceMetadataBase} from '@irian-ro/abstract-resource';
import {EmailListVO} from '@well/domain';
import {EnvironmentService} from "@irian-ro/util-environment";
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class EmailResourceService extends AbstractResourceService<EmailListVO, EmailListVO, JsonApiListResourceMetadataBase, JsonApiListResourceMetadataBase> {

  constructor(httpClient: HttpClient, environmentService: EnvironmentService) {
    super(
      httpClient,
      environmentService.getEnvironmentProperty('emailUrl'),
      EmailListVO,
      EmailListVO
    );
  }
}
